import { render, staticRenderFns } from "./InAppAspect.vue?vue&type=template&id=a119f4fa&scoped=true&"
import script from "./InAppAspect.vue?vue&type=script&lang=ts&"
export * from "./InAppAspect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a119f4fa",
  null
  
)

export default component.exports